export const QUERY_VIDEO_DROPS_LIST_SUCCESS = 'QUERY_VIDEO_DROPS_LIST_SUCCESS';
export const QUERY_VIDEO_DROPS_LIST_ERROR = 'QUERY_VIDEO_DROPS_LIST_ERROR';
export const QUERY_VIDEO_DROPS_LIST_IN_PROGRESS = 'QUERY_VIDEO_DROPS_LIST_IN_PROGRESS';

export const VIDEO_MINTS_EDIT_SET = 'VIDEO_MINTS_EDIT_SET';
